import type { SVGProps } from "react";

// Drawn by hand rather than taken from Figma's `loader`: the track is the arc's color at 30% opacity, so the spinner
// reads on any background (a filled button's white text included).
const SvgLoader = (props: SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    {/* r=9 keeps the ring inside Figma's 2px padding: its outer edge sits on the 20px box at 2–22. */}
    <circle className="opacity-30" cx={12} cy={12} r={9} stroke="currentColor" strokeWidth={2} />
    <path d="M5.25 17.95A9 9 0 0 1 12 3" stroke="currentColor" strokeWidth={2} />
  </svg>
);
export default SvgLoader;
